module.exports = __webpack_public_path__ + "static/media/corporate.43486513.svg";